import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Box, Typography, Button, Divider, Avatar
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import FolderIcon from '@mui/icons-material/Folder';
import TaskIcon from '@mui/icons-material/Task';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import PaymentIcon from '@mui/icons-material/Payment';
import LogoutIcon from '@mui/icons-material/Logout';

const MENU_ITEMS = [
  { label: 'Dashboard', icon: <DashboardIcon />, path: '/', roles: ['admin', 'miembro', 'super_admin'] },
  { label: 'Timesheet', icon: <AccessTimeIcon />, path: '/timesheet', roles: ['admin', 'miembro', 'super_admin'] },
  { label: 'Usuarios', icon: <PeopleIcon />, path: '/usuarios', roles: ['admin', 'super_admin'] },
  { label: 'Clientes', icon: <BusinessIcon />, path: '/clientes', roles: ['admin', 'super_admin'] },
  { label: 'Proyectos', icon: <FolderIcon />, path: '/proyectos', roles: ['admin', 'miembro', 'super_admin'] },
  { label: 'Tareas', icon: <TaskIcon />, path: '/tareas', roles: ['admin', 'miembro', 'super_admin'] },
  { label: 'Empresas', icon: <CorporateFareIcon />, path: '/empresas', roles: ['super_admin'] },
  { label: 'Suscripción', icon: <PaymentIcon />, path: '/suscripcion', roles: ['admin', 'super_admin'] },
];

export default function Navbar() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box sx={{
      width: 220,
      minHeight: '100vh',
      backgroundColor: '#1F4E79',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 100,
    }}>
      {/* Logo */}
      <Box sx={{ p: 3, pb: 2 }}>
        <Typography variant="h6" sx={{
          color: 'white',
          fontWeight: 'bold',
          fontSize: 16,
          lineHeight: 1.3
        }}>
          Smart Track
        </Typography>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      {/* Usuario actual */}
      <Box sx={{ px: 2, py: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Avatar sx={{ width: 32, height: 32, bgcolor: '#2E75B6', fontSize: 14 }}>
          {usuario?.nombre?.charAt(0).toUpperCase()}
        </Avatar>
        <Box>
          <Typography sx={{ color: 'white', fontSize: 13, fontWeight: 'bold', lineHeight: 1.2 }}>
            {usuario?.nombre}
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 11 }}>
            {usuario?.rol}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      {/* Menu items */}
      <Box sx={{ flex: 1, py: 1 }}>
        {MENU_ITEMS.filter(item => item.roles.includes(usuario?.rol)).map(item => {
          const isActive = location.pathname === item.path;
          return (
            <Button
              key={item.path}
              component={Link}
              to={item.path}
              startIcon={item.icon}
              fullWidth
              sx={{
                justifyContent: 'flex-start',
                px: 2.5,
                py: 1.2,
                borderRadius: 0,
                color: isActive ? 'white' : 'rgba(255,255,255,0.7)',
                backgroundColor: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
                borderLeft: isActive ? '3px solid white' : '3px solid transparent',
                fontSize: 14,
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  color: 'white',
                }
              }}
            >
              {item.label}
            </Button>
          );
        })}
      </Box>

      {/* Logout */}
      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />
      <Button
        onClick={handleLogout}
        startIcon={<LogoutIcon />}
        fullWidth
        sx={{
          justifyContent: 'flex-start',
          px: 2.5,
          py: 1.5,
          borderRadius: 0,
          color: 'rgba(255,255,255,0.7)',
          textTransform: 'none',
          fontSize: 14,
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.1)',
            color: 'white',
          }
        }}
      >
        Cerrar Sesión
      </Button>

      {/* Nombre empresa */}
      <Box sx={{
        p: 2,
        borderTop: '1px solid rgba(255,255,255,0.15)',
        backgroundColor: 'rgba(0,0,0,0.2)'
      }}>
        <Typography sx={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: 10,
          textTransform: 'uppercase',
          letterSpacing: 1
        }}>
          Client
        </Typography>
        <Typography sx={{
          color: 'rgba(255,255,255,0.85)',
          fontSize: 12,
          fontWeight: 'bold',
          mt: 0.3
        }}>
          {usuario?.empresa_nombre || 'SMART TRACK'}
        </Typography>
      </Box>
    </Box>
  );
}